module.exports = __webpack_public_path__ + "img/miniProgram.1cd9394f.svg";